/* eslint-disable max-len */
export const WorkFlexibility = (props: Record<string, any>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden={true}
        role="img"
        {...props}
    >
        <path d="M18.7497 13.6875V6.375C18.7497 6.07663 18.6311 5.79048 18.4202 5.5795C18.2092 5.36853 17.923 5.25 17.6247 5.25H6.37466C6.0763 5.25 5.79015 5.36853 5.57917 5.5795C5.36819 5.79048 5.24966 6.07663 5.24966 6.375V13.6875H18.7497Z" fill="#AEE2F7" stroke="#666666" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20.341 17.1683C20.4171 17.3395 20.4491 17.5271 20.4343 17.714C20.4195 17.9008 20.3582 18.081 20.2561 18.2382C20.1539 18.3953 20.0141 18.5244 19.8494 18.6138C19.6846 18.7032 19.5001 18.75 19.3127 18.75H4.6877C4.50027 18.75 4.3158 18.7032 4.15105 18.6138C3.9863 18.5244 3.8465 18.3953 3.74434 18.2382C3.64219 18.081 3.58091 17.9008 3.56609 17.714C3.55126 17.5271 3.58336 17.3395 3.65945 17.1683L5.2502 13.6875H18.7502L20.341 17.1683Z" fill="#AEE2F7" stroke="#666666" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.8752 16.5H13.1252" stroke="#666666" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.95202 10.5356C8.86613 10.5356 10.4178 8.98393 10.4178 7.06981C10.4178 5.1557 8.86613 3.604 6.95202 3.604C5.0379 3.604 3.48621 5.1557 3.48621 7.06981C3.48621 8.98393 5.0379 10.5356 6.95202 10.5356Z" fill="#AEE2F7" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.76187 5.2041V6.59043L7.59367 7.42222" fill="#AEE2F7" />
        <path d="M6.76187 5.2041V6.59043L7.59367 7.42222" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
WorkFlexibility.displayName = "WorkFlexibility";
